import type { HTMLAttributes } from 'react';

export type RoleBadgeRole = 'MANAGER' | 'AGENT' | 'COMPTABLE' | 'SUPER ADMIN';

interface RoleBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  role: RoleBadgeRole;
}

const roleStyles: Record<RoleBadgeRole, string> = {
  'MANAGER': 'bg-pesage-green-bg text-pesage-green',
  'AGENT': 'bg-pesage-blue-bg text-pesage-blue',
  'COMPTABLE': 'bg-pesage-amber-bg text-pesage-amber',
  'SUPER ADMIN': 'bg-pesage-purple-bg text-pesage-purple',
};

export function RoleBadge({ role, className = '', children, ...props }: RoleBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${roleStyles[role]} ${className}`.trim()}
      {...props}
    >
      {children ?? role}
    </span>
  );
}
